export class MemberEthnicity {
  id: number;
  title: string;
  referenceDataId: number;

  load_from_json(json: any): MemberEthnicity {
    this.id = json.id;
    this.title = json.title;
    this.referenceDataId = json.referenceDataId;
    return this;
  }
}
